export default __webpack_public_path__ + "static/icon-right.url-b7000cb36a0aafa3dbecbb202949efe4.svg";